import React from 'react';
import { updateUserUsername } from '../../store/actions/backendProfile';
import UserName from '../../components/UserName/UserName';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import type { RootState } from '../../store/types';

function UserNameContainer() {
    const dispatch = useAppDispatch();

    const stateProps = useAppSelector((state: RootState) => ({
        personalUsername: state.user.personalUsername || '',
        pending: state.user.pending,
        errorCode: state.user.errorCode == null ? null : String(state.user.errorCode)
    }));

    return <UserName {...stateProps} updateUsernameRequest={(nickName: string) => dispatch(updateUserUsername(nickName))} />;
}

export default UserNameContainer;
